import { AppMenuConfig, MenuAction } from '@/types/MenuTypes';

// Default system menus (when no app is active)
export const defaultSystemMenus: AppMenuConfig = {
  appName: 'Open Insurance',
  file: [
    { id: 'new-task', label: 'New Task', shortcut: '⌘N' },
    { id: 'new-note', label: 'New Note', shortcut: '⌘⇧N' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'preferences', label: 'Preferences...', shortcut: '⌘,' },
  ],
  edit: [
    { id: 'undo', label: 'Undo', shortcut: '⌘Z', disabled: true },
    { id: 'redo', label: 'Redo', shortcut: '⌘⇧Z', disabled: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'cut', label: 'Cut', shortcut: '⌘X', disabled: true },
    { id: 'copy', label: 'Copy', shortcut: '⌘C', disabled: true },
    { id: 'paste', label: 'Paste', shortcut: '⌘V', disabled: true },
  ],
  view: [
    { id: 'show-dock', label: 'Show Dock', checked: true },
    { id: 'show-widgets', label: 'Show Widgets', checked: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'fullscreen', label: 'Enter Full Screen', shortcut: '⌃⌘F' },
  ],
  window: [
    { id: 'minimize', label: 'Minimize', shortcut: '⌘M', disabled: true },
    { id: 'zoom', label: 'Zoom', disabled: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'bring-all-front', label: 'Bring All to Front' },
  ],
  help: [
    { id: 'about', label: 'About Open Insurance' },
    { id: 'shortcuts', label: 'Keyboard Shortcuts' },
    { id: 'support', label: 'Support' },
  ],
};

// Notes app menu configuration
export const notesMenuConfig: AppMenuConfig = {
  appName: 'Notes',
  file: [
    { id: 'new-note', label: 'New Note', shortcut: '⌘N' },
    { id: 'new-folder', label: 'New Folder', shortcut: '⌘⇧N' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'save', label: 'Save', shortcut: '⌘S' },
    { id: 'export', label: 'Export...', shortcut: '⌘E' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'delete', label: 'Delete Note', shortcut: '⌘⌫' },
  ],
  edit: [
    { id: 'undo', label: 'Undo', shortcut: '⌘Z' },
    { id: 'redo', label: 'Redo', shortcut: '⌘⇧Z' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'cut', label: 'Cut', shortcut: '⌘X' },
    { id: 'copy', label: 'Copy', shortcut: '⌘C' },
    { id: 'paste', label: 'Paste', shortcut: '⌘V' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'select-all', label: 'Select All', shortcut: '⌘A' },
    { id: 'find', label: 'Find...', shortcut: '⌘F' },
  ],
  view: [
    { id: 'show-sidebar', label: 'Show Sidebar', shortcut: '⌘⇧S', checked: true },
    { id: 'show-folders', label: 'Show Folders', checked: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'zoom-in', label: 'Zoom In', shortcut: '⌘+' },
    { id: 'zoom-out', label: 'Zoom Out', shortcut: '⌘-' },
    { id: 'actual-size', label: 'Actual Size', shortcut: '⌘0' },
  ],
  window: [
    { id: 'minimize', label: 'Minimize', shortcut: '⌘M' },
    { id: 'zoom', label: 'Zoom' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'bring-all-front', label: 'Bring All to Front' },
  ],
  help: [
    { id: 'notes-help', label: 'Notes Help' },
    { id: 'keyboard-shortcuts', label: 'Keyboard Shortcuts' },
  ],
};

// Task Creator app menu configuration
export const taskCreatorMenuConfig: AppMenuConfig = {
  appName: 'Task Creator',
  file: [
    { id: 'new-task', label: 'New Task', shortcut: '⌘N' },
    { id: 'save-template', label: 'Save as Template...', shortcut: '⌘T' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'save', label: 'Save Task', shortcut: '⌘S' },
    { id: 'save-and-new', label: 'Save and Create New', shortcut: '⌘⇧S' },
  ],
  edit: [
    { id: 'undo', label: 'Undo', shortcut: '⌘Z' },
    { id: 'redo', label: 'Redo', shortcut: '⌘⇧Z' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'cut', label: 'Cut', shortcut: '⌘X' },
    { id: 'copy', label: 'Copy', shortcut: '⌘C' },
    { id: 'paste', label: 'Paste', shortcut: '⌘V' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'clear-form', label: 'Clear Form' },
  ],
  view: [
    { id: 'show-preview', label: 'Show Preview', checked: false },
    { id: 'show-templates', label: 'Show Templates' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'fullscreen', label: 'Enter Full Screen', shortcut: '⌃⌘F' },
  ],
  window: [
    { id: 'minimize', label: 'Minimize', shortcut: '⌘M' },
    { id: 'zoom', label: 'Zoom' },
  ],
  help: [
    { id: 'task-help', label: 'Task Creator Help' },
    { id: 'priority-guide', label: 'Priority Guide' },
  ],
};

// All Tasks app menu configuration
export const allTasksMenuConfig: AppMenuConfig = {
  appName: 'All Tasks',
  file: [
    { id: 'new-task', label: 'New Task', shortcut: '⌘N' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'export-tasks', label: 'Export Tasks...', shortcut: '⌘E' },
    { id: 'import-tasks', label: 'Import Tasks...' },
  ],
  edit: [
    { id: 'select-all', label: 'Select All', shortcut: '⌘A' },
    { id: 'select-completed', label: 'Select Completed' },
    { id: 'select-overdue', label: 'Select Overdue' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'mark-complete', label: 'Mark Complete' },
    { id: 'mark-incomplete', label: 'Mark Incomplete' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'delete-selected', label: 'Delete Selected', shortcut: '⌫' },
  ],
  view: [
    { id: 'show-completed', label: 'Show Completed', checked: true },
    { id: 'show-sidebar', label: 'Show Sidebar', checked: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'sort-by-date', label: 'Sort by Date' },
    { id: 'sort-by-priority', label: 'Sort by Priority' },
    { id: 'sort-by-status', label: 'Sort by Status' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'filter-today', label: 'Show Today Only' },
    { id: 'filter-week', label: 'Show This Week' },
  ],
};

// EHR Core app menu configuration
export const ehrCoreMenuConfig: AppMenuConfig = {
  appName: 'EHR Core (HCU)',
  file: [
    { id: 'new-patient', label: 'New Patient', shortcut: '⌘N' },
    { id: 'new-encounter', label: 'New Encounter', shortcut: '⌘⇧N' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'save', label: 'Save', shortcut: '⌘S' },
    { id: 'finalize', label: 'Finalize Encounter', shortcut: '⌘⇧F' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'export-record', label: 'Export Patient Record...', shortcut: '⌘E' },
    { id: 'print', label: 'Print', shortcut: '⌘P' },
  ],
  edit: [
    { id: 'undo', label: 'Undo', shortcut: '⌘Z' },
    { id: 'redo', label: 'Redo', shortcut: '⌘⇧Z' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'cut', label: 'Cut', shortcut: '⌘X' },
    { id: 'copy', label: 'Copy', shortcut: '⌘C' },
    { id: 'paste', label: 'Paste', shortcut: '⌘V' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'find-patient', label: 'Find Patient...', shortcut: '⌘F' },
    { id: 'ai-copilot', label: 'AI Co-Pilot...', shortcut: '⌘K' },
  ],
  view: [
    { id: 'show-timeline', label: 'Show Timeline', checked: true },
    { id: 'show-vitals', label: 'Show Vitals Panel', checked: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'view-encounters', label: 'Encounters' },
    { id: 'view-orders', label: 'Orders' },
    { id: 'view-labs', label: 'Labs' },
    { id: 'view-imaging', label: 'Imaging' },
    { id: 'view-documents', label: 'Documents' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'code-lookup', label: 'ICD-10 Code Lookup' },
    { id: 'drug-lookup', label: 'Drug Reference' },
    { id: 'audit-log', label: 'View Audit Log' },
  ],
  window: [
    { id: 'minimize', label: 'Minimize', shortcut: '⌘M' },
    { id: 'zoom', label: 'Zoom' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'bring-all-front', label: 'Bring All to Front' },
  ],
  help: [
    { id: 'ehr-help', label: 'EHR Core Help' },
    { id: 'soap-guide', label: 'SOAP Note Guide' },
    { id: 'keyboard-shortcuts', label: 'Keyboard Shortcuts' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'compliance', label: 'Compliance Information' },
  ],
};

// Registry of all menu configurations
export const menuRegistry: Record<string, AppMenuConfig> = {
  'system': defaultSystemMenus,
  'notes': notesMenuConfig,
  'task-creator': taskCreatorMenuConfig,
  'all-tasks': allTasksMenuConfig,
  'ehr-core': ehrCoreMenuConfig,
};

// Helper function to get menu config for an app
export const getMenuConfigForApp = (appType: string): AppMenuConfig => {
  return menuRegistry[appType] || defaultSystemMenus;
};